import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Absolute, Relative, Flex, BackgroundImage } from 'pcln-design-system';
import { CircleSmall, PricelineSidewaysP } from '../svg-build';
const baseZindex = 1;
const CropFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "SilhouetteSemicircle__CropFlex",
  componentId: "sc-pdbyco-0"
})(["overflow:hidden;"]);
const OnTopBackgroundImage = /*#__PURE__*/styled(BackgroundImage).withConfig({
  displayName: "SilhouetteSemicircle__OnTopBackgroundImage",
  componentId: "sc-pdbyco-1"
})(["z-index:", ";"], baseZindex + 4);
const CroppedImage = ({
  imageMirrorProps,
  imageUrl
}) => React.createElement(CropFlex, {
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: 'full',
  ...imageMirrorProps
}, React.createElement(OnTopBackgroundImage, {
  width: '100%',
  height: '100%',
  image: imageUrl
}));
/** @public */
export const Stage = /*#__PURE__*/styled(Relative).attrs({
  minHeight: ['206px', null, '480px']
}).withConfig({
  displayName: "SilhouetteSemicircle__Stage",
  componentId: "sc-pdbyco-2"
})(["overflow:clip;", "{overflow-x:unset;}"], themeGet('mediaQueries.md'));
/** @public */
export const StyledP = /*#__PURE__*/styled(PricelineSidewaysP).withConfig({
  displayName: "SilhouetteSemicircle__StyledP",
  componentId: "sc-pdbyco-3"
})(["transform:", ";&,& > svg{width:100%;height:100%;}"], props => props.mirror === 'left' ? 'scaleX(-1)' : '');
/** @public */
export const StyledCircleSmall = /*#__PURE__*/styled(CircleSmall).withConfig({
  displayName: "SilhouetteSemicircle__StyledCircleSmall",
  componentId: "sc-pdbyco-4"
})(["&,& > svg{width:100%;height:100%;}"]);
/** @public */
export const CircleStage = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "SilhouetteSemicircle__CircleStage",
  componentId: "sc-pdbyco-5"
})(["z-index:", ";"], baseZindex + 2);
/** @public */
export const PStage = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "SilhouetteSemicircle__PStage",
  componentId: "sc-pdbyco-6"
})(["z-index:", ";"], baseZindex + 1);
export const ImageStage = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "SilhouetteSemicircle__ImageStage",
  componentId: "sc-pdbyco-7"
})(["z-index:", ";margin-left:auto;margin-right:auto;", "{z-index:", ";}"], baseZindex + 4, themeGet('mediaQueries.md'), baseZindex);
/** @public */
const SilhouetteSemicircle = ({
  mirror = 'right',
  imageUrl,
  className
}) => {
  const sphereProps = mirror === 'left' ? {
    left: ['3%', null, '-10%', null, '-12%', '-16%']
  } : {
    right: ['5%', null, '-10%', null, '-12%', '-16%']
  };
  const P_OFFSET = ['-40%', null, '-18%'];
  const pProps = mirror === 'left' ? {
    right: P_OFFSET,
    transform: 'scaleX(-1)'
  } : {
    left: P_OFFSET
  };
  return React.createElement(Stage, {
    className: className
  }, React.createElement(CircleStage, {
    size: ['85px', null, '100px', null, '125px', '150px'],
    bottom: [null, null, '0'],
    ...sphereProps
  }, React.createElement(StyledCircleSmall, null)), React.createElement(PStage, {
    width: ['291.04px', null, null, '400px', '450px', '551.25px'],
    top: ['-65%', null, '-29%', '-42%', '-52%', '-65%'],
    ...pProps
  }, React.createElement(StyledP, {
    mirror: mirror
  })), React.createElement(ImageStage, {
    width: ['90%', null, null, null, '100%', '748px'],
    height: ['175px', null, '374px'],
    bottom: ['8%', null, null, null, '12%'],
    left: [0, null, '-2%', null, '-10%'],
    right: [0, null, '-2%', null, '-10%']
  }, React.createElement(CroppedImage, {
    imageUrl: imageUrl,
    imageMirrorProps: {
      rounded: 'top'
    }
  })));
};
/** @public */
export { SilhouetteSemicircle };